import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommodityFormComponent } from '../commodity-form/commodity-form.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WeightUnitEnum } from '../../../enum/weight-unit.enum';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { combineLatest, Subscription } from 'rxjs';
import {
    selectCommodityEditorCommodity, selectCommodityEditorLoading,
    selectCommodityEditorSaving
} from '../../../store/commodity-editor/commodity-editor.state';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { map, startWith } from 'rxjs/operators';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatDialogRef } from '@angular/material/dialog';
import { commodityEditorSaveRequest, commodityEditorSetCommodity } from '../../../store/commodity-editor/commodity-editor.actions';
import { IconComponent } from '../../shared/icon/icon.component';
import { emptyCommodity } from '../../../constants/empty-commodity';
import { harmonizedCodeValidator } from '../../../constraints/harmonized-code.validator';
import { createCommodityFormGroup } from '../../../constants/commodity-form-group';
import { CurrencyEnum } from '../../../enum/currency.enum';

@Component({
    selector: 'app-commodity-edit',
    imports: [
    CommodityFormComponent,
    AsyncPipe,
    MatProgressSpinner,
    MatButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    IconComponent
],
    templateUrl: './commodity-edit.component.html',
    styleUrl: './commodity-edit.component.scss'
})
export class CommodityEditComponent implements OnInit, OnDestroy {

    public KG = WeightUnitEnum.KG;
    public LB = WeightUnitEnum.LB;

    public formGroup = createCommodityFormGroup();

    public currency$ = this.formGroup.valueChanges.pipe(
        startWith(this.formGroup.value),
        map(value => value.currency)
    );
    public weightUnit$ = this.formGroup.valueChanges.pipe(
        startWith(this.formGroup.value),
        map(value => value.weightUnit)
    );

    private stateSubscription: Subscription;

    constructor(private dialogRef: MatDialogRef<CommodityEditComponent>, private store: Store<AppState>) {
    }

    public saving$ = this.store.select(selectCommodityEditorSaving);
    public loading$ = this.store.select(selectCommodityEditorLoading);
    public disableSave$ = combineLatest([ this.saving$, this.loading$, this.formGroup.valueChanges ]).pipe(
        startWith([ false, false, this.formGroup.value ]),
        map(([ saving, loading, value ]) => saving
            || loading
            || this.formGroup.invalid
        )
    );

    ngOnInit(): void {
        this.stateSubscription = this.store.select(selectCommodityEditorCommodity).subscribe((commodity) => {
            this.formGroup.patchValue(commodity);
        });
    }

    ngOnDestroy(): void {
        this.stateSubscription.unsubscribe();
    }

    changeCurrency(currency: CurrencyEnum): void {
        this.formGroup.get('currency').setValue(currency);
    }

    changeWeightUnit(weightUnit: WeightUnitEnum): void {
        this.formGroup.get('weightUnit').setValue(weightUnit);
    }

    cancel(): void {
        this.dialogRef.close(null);
    }

    submit(): void {
        this.store.dispatch(commodityEditorSetCommodity({ commodity: this.formGroup.value }));
        this.store.dispatch(commodityEditorSaveRequest());
    }
}
